import React, { useEffect, useState } from "react";
import { useOrgContextStore } from "@/components/main/stores/orgContextStore";
import { orgImageUrl, type Org } from "@/lib/api/organizations";

const SIZE_CLASSES = {
  sm: "h-5 w-5",
  md: "h-6 w-6",
  lg: "h-12 w-12",
} as const;

const FONT_SIZES = {
  sm: "var(--font-size-x-small)",
  md: "var(--font-size)",
  lg: "var(--font-size-large)",
} as const;

/// The org's mark — its uploaded image, or its initial. One component so an
/// upload changes the switcher, the settings tile and every future chip at
/// once. Circular, matching AvatarInitial: DESIGN.md's one radius exception.
export const OrgMark: React.FC<{
  org: Pick<Org, "org_id" | "name" | "has_image">;
  size: keyof typeof SIZE_CLASSES;
}> = ({ org, size }) => {
  const imageVersion = useOrgContextStore((s) => s.imageVersion);
  const [failed, setFailed] = useState(false);
  const src = orgImageUrl(org.org_id, imageVersion);

  useEffect(() => {
    setFailed(false);
  }, [src, org.has_image]);

  return (
    <span
      aria-hidden
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-border bg-accent-subtle font-semibold text-fg ${SIZE_CLASSES[size]}`}
      style={{ fontSize: FONT_SIZES[size] }}
    >
      {org.has_image && !failed ? (
        <img
          src={src}
          alt=""
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        org.name.charAt(0).toUpperCase()
      )}
    </span>
  );
};
